export default __webpack_public_path__ + "choose_corner_3.c92289.svg";